/**
 * ALL available SVG icons which can be use in application
 */
const SvgIcons = {
  encryptedIcon: (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 13H9.5L8.925 9.775C9.25833 9.60833 9.52083 9.36667 9.7125 9.05C9.90417 8.73333 10 8.38333 10 8C10 7.45 9.80417 6.97917 9.4125 6.5875C9.02083 6.19583 8.55 6 8 6C7.45 6 6.97917 6.19583 6.5875 6.5875C6.19583 6.97917 6 7.45 6 8C6 8.38333 6.09583 8.73333 6.2875 9.05C6.47917 9.36667 6.74167 9.60833 7.075 9.775L6.5 13ZM8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V9.1C16 11.6333 15.2458 13.9375 13.7375 16.0125C12.2292 18.0875 10.3167 19.4167 8 20ZM8 17.9C9.73333 17.35 11.1667 16.25 12.3 14.6C13.4333 12.95 14 11.1167 14 9.1V4.375L8 2.125L2 4.375V9.1C2 11.1167 2.56667 12.95 3.7 14.6C4.83333 16.25 6.26667 17.35 8 17.9Z"
        fill="currentColor"
      />
    </svg>
  ),

  editIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M12.6784 4.98533L13.8466 3.81719C14.4917 3.17205 15.5377 3.17205 16.1828 3.81719C16.828 4.46234 16.828 5.50832 16.1828 6.15346L15.0147 7.3216M12.6784 4.98533L5.81689 11.8469C4.94581 12.718 4.51026 13.1535 4.21368 13.6843C3.9171 14.215 3.61871 15.4683 3.33337 16.6667C4.53178 16.3813 5.78503 16.0829 6.31578 15.7864C6.84653 15.4898 7.28207 15.0542 8.15316 14.1831L15.0147 7.3216M12.6784 4.98533L15.0147 7.3216"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16675 16.6667H14.1667"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  ),

  eyeIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M17.9533 9.20448C18.2066 9.55975 18.3333 9.73738 18.3333 10.0003C18.3333 10.2633 18.2066 10.4409 17.9533 10.7962C16.8149 12.3925 13.9076 15.8337 9.99996 15.8337C6.09228 15.8337 3.18504 12.3925 2.04666 10.7962C1.7933 10.4409 1.66663 10.2633 1.66663 10.0003C1.66663 9.73738 1.7933 9.55975 2.04666 9.20448C3.18504 7.60819 6.09228 4.16699 9.99996 4.16699C13.9076 4.16699 16.8149 7.60819 17.9533 9.20448Z"
          stroke="#141B34"
          strokeWidth="1.5"
        />
        <path
          d="M12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10Z"
          stroke="#141B34"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),

  backwardIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M4.00686 7.86781L5.64461 6.22432C6.82464 5.04016 7.28719 4.40314 7.92615 4.62834C8.72294 4.90914 8.46064 6.68093 8.46064 7.27909C9.69944 7.27909 10.9874 7.16899 12.2085 7.39839C16.2395 8.1557 17.5 11.4296 17.5 15.0002C16.3591 14.192 15.2193 13.331 13.8481 12.9565C12.1364 12.4889 10.2247 12.712 8.46064 12.712C8.46064 13.3101 8.72294 15.082 7.92615 15.3628C7.20209 15.6179 6.82464 14.9509 5.64461 13.7668L4.00686 12.1233C3.00229 11.1152 2.5 10.6111 2.5 9.99555C2.5 9.37996 3.00229 8.87591 4.00686 7.86781Z"
          stroke="#141B34"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),

  deleteIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M16.25 4.58334L15.7336 12.9376C15.6016 15.072 15.5356 16.1393 15.0006 16.9066C14.7361 17.2859 14.3955 17.6061 14.0006 17.8467C13.2018 18.3333 12.1325 18.3333 9.99395 18.3333C7.8526 18.3333 6.78192 18.3333 5.98254 17.8458C5.58733 17.6047 5.24666 17.284 4.98224 16.904C4.4474 16.1355 4.38288 15.0668 4.25384 12.9293L3.75 4.58334"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M2.5 4.58333H17.5M13.3798 4.58333L12.8109 3.40977C12.433 2.63021 12.244 2.24043 11.9181 1.99734C11.8458 1.94341 11.7692 1.89545 11.6892 1.85391C11.3283 1.66666 10.8951 1.66666 10.0288 1.66666C9.14069 1.66666 8.69665 1.66666 8.32974 1.86176C8.24842 1.905 8.17082 1.95491 8.09774 2.01097C7.76803 2.26391 7.58386 2.66796 7.2155 3.47605L6.71077 4.58333"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M7.91663 13.75L7.91663 8.75"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12.0834 13.75L12.0834 8.75"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  ),

  keyIcon: (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 6.5C4.8375 6.5 4.48438 6.35313 4.19063 6.05937C3.89688 5.76562 3.75 5.4125 3.75 5C3.75 4.5875 3.89688 4.23438 4.19063 3.94063C4.48438 3.64688 4.8375 3.5 5.25 3.5C5.6625 3.5 6.01562 3.64688 6.30937 3.94063C6.60313 4.23438 6.75 4.5875 6.75 5C6.75 5.4125 6.60313 5.76562 6.30937 6.05937C6.01562 6.35313 5.6625 6.5 5.25 6.5ZM5.25 9.5C4 9.5 2.9375 9.0625 2.0625 8.1875C1.1875 7.3125 0.75 6.25 0.75 5C0.75 3.75 1.1875 2.6875 2.0625 1.8125C2.9375 0.9375 4 0.5 5.25 0.5C6.0875 0.5 6.84688 0.70625 7.52813 1.11875C8.20938 1.53125 8.75 2.075 9.15 2.75H15.75L18 5L14.625 8.375L13.125 7.25L11.625 8.375L10.0312 7.25H9.15C8.75 7.925 8.20938 8.46875 7.52813 8.88125C6.84688 9.29375 6.0875 9.5 5.25 9.5ZM5.25 8C5.95 8 6.56563 7.7875 7.09688 7.3625C7.62813 6.9375 7.98125 6.4 8.15625 5.75H10.5L11.5875 6.51875L13.125 5.375L14.4562 6.40625L15.8625 5L15.1125 4.25H8.15625C7.98125 3.6 7.62813 3.0625 7.09688 2.6375C6.56563 2.2125 5.95 2 5.25 2C4.425 2 3.71875 2.29375 3.13125 2.88125C2.54375 3.46875 2.25 4.175 2.25 5C2.25 5.825 2.54375 6.53125 3.13125 7.11875C3.71875 7.70625 4.425 8 5.25 8Z"
        fill="currentColor"
      />
    </svg>
  ),
  dashboardIcon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 21.5L16.5 21.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.93924 15.5168C1.49796 12.6453 1.27733 11.2095 1.82021 9.93672C2.36309 8.6639 3.56753 7.79304 5.97642 6.05133L7.77624 4.75C10.7729 2.58333 12.2712 1.5 14 1.5C15.7288 1.5 17.2271 2.58333 20.2238 4.75L22.0236 6.05133C24.4325 7.79304 25.6369 8.6639 26.1798 9.93672C26.7227 11.2095 26.502 12.6453 26.0608 15.5168L25.6845 17.9655C25.0589 22.0362 24.7461 24.0715 23.2862 25.2857C21.8264 26.5 19.6921 26.5 15.4235 26.5H12.5765C8.30792 26.5 6.17363 26.5 4.71375 25.2857C3.25386 24.0715 2.94109 22.0362 2.31553 17.9655L1.93924 15.5168Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  UserGroupIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9674 22.5C26.9041 22.5 27.6491 21.9106 28.318 21.0864C29.6873 19.3993 27.4391 18.051 26.5816 17.3908C25.7099 16.7195 24.7367 16.3393 23.7499 16.25M22.4999 13.75C24.2258 13.75 25.6249 12.3509 25.6249 10.625C25.6249 8.89911 24.2258 7.5 22.4999 7.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.03236 22.5C3.09573 22.5 2.35075 21.9106 1.68184 21.0864C0.312523 19.3993 2.56075 18.051 3.41822 17.3908C4.28988 16.7195 5.26314 16.3393 6.24991 16.25M6.87491 13.75C5.14902 13.75 3.74991 12.3509 3.74991 10.625C3.74991 8.89911 5.14902 7.5 6.87491 7.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.1046 18.889C8.8274 19.6787 5.4786 21.2914 7.51824 23.3093C8.51459 24.295 9.62427 25 11.0194 25H18.9803C20.3755 25 21.4851 24.295 22.4815 23.3093C24.5211 21.2914 21.1723 19.6787 19.8951 18.889C16.9 17.037 13.0997 17.037 10.1046 18.889Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3749 9.375C19.3749 11.7912 17.4161 13.75 14.9999 13.75C12.5836 13.75 10.6249 11.7912 10.6249 9.375C10.6249 6.95875 12.5836 5 14.9999 5C17.4161 5 19.3749 6.95875 19.3749 9.375Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),
  UserSheildIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 17.5583C12.2409 17.3004 9.41322 17.8984 6.97197 19.352C5.20351 20.405 0.566706 22.5551 3.39083 25.2457C4.77039 26.56 6.30686 27.5 8.23859 27.5H16.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.375 8.125C19.375 11.2316 16.8566 13.75 13.75 13.75C10.6434 13.75 8.125 11.2316 8.125 8.125C8.125 5.0184 10.6434 2.5 13.75 2.5C16.8566 2.5 19.375 5.0184 19.375 8.125Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M22.4991 17.5C20.916 17.5 19.8896 18.5095 18.6756 18.8775C18.182 19.0271 17.9352 19.1019 17.8354 19.2073C17.7355 19.3128 17.7062 19.4669 17.6477 19.7751C17.0218 23.073 18.3899 26.122 21.6528 27.3087C22.0034 27.4362 22.1786 27.5 22.5008 27.5C22.8229 27.5 22.9982 27.4362 23.3487 27.3087C26.6114 26.122 27.9782 23.073 27.3521 19.7751C27.2936 19.4668 27.2643 19.3127 27.1644 19.2072C27.0645 19.1018 26.8177 19.027 26.3242 18.8775C25.1098 18.5096 24.0822 17.5 22.4991 17.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  StoreIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.63999 6.54386L2.92606 6.31407L3.63999 6.54386ZM2.78533 9.19916L3.49926 9.42895L2.78533 9.19916ZM26.36 6.54386L25.6461 6.77365V6.77365L26.36 6.54386ZM27.2147 9.19916L27.9286 8.96937L27.2147 9.19916ZM11.937 12.3482C11.646 12.0534 11.1711 12.0504 10.8764 12.3414C10.5816 12.6324 10.5786 13.1073 10.8696 13.4021L11.937 12.3482ZM19.1305 12.3475C18.8396 12.0526 18.3647 12.0495 18.0699 12.3404C17.7751 12.6314 17.7719 13.1063 18.0629 13.4011L19.1305 12.3475ZM2.96916 11.9625L3.57717 11.5234H3.57717L2.96916 11.9625ZM13.4094 10.8132C13.5133 10.4122 13.2725 10.0029 12.8715 9.89899C12.4706 9.79506 12.0613 10.0359 11.9573 10.4368L13.4094 10.8132ZM20.6019 10.8132C20.7058 10.4122 20.465 10.0029 20.0641 9.89899C19.6631 9.79506 19.2538 10.0359 19.1499 10.4368L20.6019 10.8132ZM27.0308 11.9625L26.4228 11.5234L27.0308 11.9625ZM27.4669 10.8833L26.7258 10.7677V10.7677L27.4669 10.8833ZM2.53313 10.8833L1.7921 10.999L2.53313 10.8833ZM5.06884 3.59689L4.62022 2.99587V2.99587L5.06884 3.59689ZM3.63999 6.54386L2.92606 6.31407L2.0714 8.96937L2.78533 9.19916L3.49926 9.42895L4.35392 6.77365L3.63999 6.54386ZM26.36 6.54386L25.6461 6.77365L26.5007 9.42895L27.2147 9.19916L27.9286 8.96937L27.0739 6.31407L26.36 6.54386ZM8.22027 3.125V3.875L21.7797 3.875V3.125V2.375L8.22027 2.375V3.125ZM14.9992 14.375L14.9992 13.625C13.7985 13.625 12.7152 13.1364 11.937 12.3482L11.4033 12.8751L10.8696 13.4021C11.9192 14.4651 13.3828 15.125 14.9992 15.125V14.375ZM22.1934 14.375V13.625C20.9924 13.625 19.9087 13.1361 19.1305 12.3475L18.5967 12.8743L18.0629 13.4011C19.1125 14.4647 20.5765 15.125 22.1934 15.125V14.375ZM7.80663 14.375V13.625C6.20701 13.625 4.473 12.7638 3.57717 11.5234L2.96916 11.9625L2.36116 12.4017C3.55421 14.0535 5.75192 15.125 7.80663 15.125V14.375ZM12.6834 10.625L11.9573 10.4368C11.4828 12.2675 9.80611 13.625 7.80663 13.625V14.375V15.125C10.4997 15.125 12.7659 13.2956 13.4094 10.8132L12.6834 10.625ZM19.8759 10.625L19.1499 10.4368C18.6754 12.2675 16.9986 13.625 14.9992 13.625L14.9992 14.375V15.125C17.6922 15.125 19.9584 13.2956 20.6019 10.8132L19.8759 10.625ZM27.0308 11.9625L26.4228 11.5234C25.527 12.7638 23.793 13.625 22.1934 13.625V14.375V15.125C24.2481 15.125 26.4458 14.0535 27.6388 12.4017L27.0308 11.9625ZM27.2147 9.19916L26.5007 9.42895C26.7341 10.1539 26.79 10.3567 26.7258 10.7677L27.4669 10.8833L28.2079 10.999C28.3331 10.1969 28.1577 9.68125 27.9286 8.96937L27.2147 9.19916ZM27.0308 11.9625L27.6388 12.4017C27.7463 12.2529 27.8787 12.0738 27.984 11.8369C28.0905 11.5974 28.1556 11.3341 28.2079 10.999L27.4669 10.8833L26.7258 10.7677C26.6835 11.0392 26.6444 11.1578 26.6134 11.2276C26.5813 11.2998 26.543 11.3571 26.4228 11.5234L27.0308 11.9625ZM26.36 6.54386L27.0739 6.31407C26.8136 5.50514 26.6005 4.83958 26.3676 4.32125C26.1276 3.78687 25.8365 3.3368 25.3798 2.99587L24.9312 3.59689L24.4825 4.19792C24.658 4.32888 24.8158 4.52727 24.9994 4.93589C25.1901 5.36055 25.3753 5.93254 25.6461 6.77365L26.36 6.54386ZM21.7797 3.125V3.875C22.6373 3.875 23.2154 3.87621 23.6601 3.9288C24.0841 3.97892 24.3093 4.06861 24.4825 4.19792L24.9312 3.59689L25.3798 2.99587C24.9208 2.65329 24.4101 2.50702 23.8362 2.43917C23.2832 2.37379 22.6016 2.375 21.7797 2.375V3.125ZM2.78533 9.19916L2.0714 8.96937C1.84227 9.68125 1.66692 10.1969 1.7921 10.999L2.53313 10.8833L3.27416 10.7677C3.21003 10.3567 3.26592 10.1539 3.49926 9.42895L2.78533 9.19916ZM2.96916 11.9625L3.57717 11.5234C3.45704 11.3571 3.41874 11.2998 3.38662 11.2276C3.35562 11.1578 3.31652 11.0392 3.27416 10.7677L2.53313 10.8833L1.7921 10.999C1.84439 11.3341 1.90951 11.5974 2.01597 11.8369C2.12131 12.0738 2.2537 12.2529 2.36116 12.4017L2.96916 11.9625ZM3.63999 6.54386L4.35392 6.77365C4.62465 5.93254 4.80989 5.36055 5.00065 4.93589C5.1842 4.52727 5.34202 4.32888 5.51747 4.19792L5.06884 3.59689L4.62022 2.99587C4.16346 3.3368 3.8724 3.78687 3.63236 4.32125C3.39952 4.83958 3.18643 5.50514 2.92606 6.31407L3.63999 6.54386ZM8.22027 3.125V2.375C7.3984 2.375 6.71681 2.37379 6.16376 2.43917C5.58991 2.50702 5.07917 2.65329 4.62022 2.99587L5.06884 3.59689L5.51747 4.19792C5.69072 4.06861 5.91595 3.97892 6.33989 3.9288C6.78464 3.87621 7.36265 3.875 8.22027 3.875V3.125Z"
        fill="black"
      />
      <path
        d="M3.75 13.125L3.75 19.375C3.75 22.9105 3.75 24.6783 4.84835 25.7767C5.9467 26.875 7.71447 26.875 11.25 26.875L18.75 26.875C22.2855 26.875 24.0533 26.875 25.1517 25.7767C26.25 24.6783 26.25 22.9105 26.25 19.375V13.125"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M8.75 22.5H13.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  DepartmentsIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 7.5C2.5 5.14298 2.5 3.96447 3.23223 3.23223C3.96447 2.5 5.14298 2.5 7.5 2.5C9.85702 2.5 11.0355 2.5 11.7678 3.23223C12.5 3.96447 12.5 5.14298 12.5 7.5V10C12.5 12.357 12.5 13.5355 11.7678 14.2678C11.0355 15 9.85702 15 7.5 15C5.14298 15 3.96447 15 3.23223 14.2678C2.5 13.5355 2.5 12.357 2.5 10V7.5Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M2.5 23.75C2.5 22.5851 2.5 22.0027 2.6903 21.5433C2.94404 20.9307 3.43072 20.444 4.04329 20.1903C4.50272 20 5.08515 20 6.25 20H8.75C9.91485 20 10.4973 20 10.9567 20.1903C11.5693 20.444 12.056 20.9307 12.3097 21.5433C12.5 22.0027 12.5 22.5851 12.5 23.75C12.5 24.9149 12.5 25.4973 12.3097 25.9567C12.056 26.5693 11.5693 27.056 10.9567 27.3097C10.4973 27.5 9.91485 27.5 8.75 27.5H6.25C5.08515 27.5 4.50272 27.5 4.04329 27.3097C3.43072 27.056 2.94404 26.5693 2.6903 25.9567C2.5 25.4973 2.5 24.9149 2.5 23.75Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M17.5 20C17.5 17.643 17.5 16.4645 18.2322 15.7322C18.9645 15 20.143 15 22.5 15C24.857 15 26.0355 15 26.7678 15.7322C27.5 16.4645 27.5 17.643 27.5 20V22.5C27.5 24.857 27.5 26.0355 26.7678 26.7678C26.0355 27.5 24.857 27.5 22.5 27.5C20.143 27.5 18.9645 27.5 18.2322 26.7678C17.5 26.0355 17.5 24.857 17.5 22.5V20Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M17.5 6.25C17.5 5.08515 17.5 4.50272 17.6903 4.04329C17.944 3.43072 18.4307 2.94404 19.0433 2.6903C19.5027 2.5 20.0851 2.5 21.25 2.5H23.75C24.9149 2.5 25.4973 2.5 25.9567 2.6903C26.5693 2.94404 27.056 3.43072 27.3097 4.04329C27.5 4.50272 27.5 5.08515 27.5 6.25C27.5 7.41485 27.5 7.99728 27.3097 8.45671C27.056 9.06928 26.5693 9.55596 25.9567 9.8097C25.4973 10 24.9149 10 23.75 10H21.25C20.0851 10 19.5027 10 19.0433 9.8097C18.4307 9.55596 17.944 9.06928 17.6903 8.45671C17.5 7.99728 17.5 7.41485 17.5 6.25Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),
  ChannelsIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.125 5H6.875V19.375C6.875 20.4199 6.875 20.9424 6.93069 21.3812C7.3326 24.5484 9.82658 27.0424 12.9938 27.4443C13.4326 27.5 13.9551 27.5 15 27.5C16.0449 27.5 16.5674 27.5 17.0062 27.4443C20.1734 27.0424 22.6674 24.5484 23.0693 21.3812C23.125 20.9424 23.125 20.4199 23.125 19.375V10C23.125 7.64298 23.125 6.46447 22.3928 5.73223C21.6605 5 20.482 5 18.125 5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 22.5H16.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 10.5357C10.625 10.037 10.625 9.78762 10.6951 9.58715C10.8208 9.22809 11.1031 8.94579 11.4622 8.82015C11.6626 8.75 11.912 8.75 12.4107 8.75H17.5893C18.088 8.75 18.3374 8.75 18.5378 8.82015C18.8969 8.94579 19.1792 9.22809 19.3049 9.58715C19.375 9.78762 19.375 10.037 19.375 10.5357V11.25C19.375 11.8306 19.375 12.1209 19.3365 12.3639C19.1247 13.701 18.076 14.7497 16.7389 14.9615C16.4959 15 15.5806 15 15 15C14.4194 15 13.5041 15 13.2611 14.9615C11.924 14.7497 10.8753 13.701 10.6635 12.3639C10.625 12.1209 10.625 11.8306 10.625 11.25V10.5357Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 5L6.875 2.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  AlertsIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.65214 12.1036C9.66923 6.76494 11.1778 4.09561 13.2478 3.40847C14.3866 3.03046 15.6134 3.03046 16.7522 3.40847C18.8222 4.09561 20.3308 6.76494 23.3479 12.1036C26.365 17.4423 27.8735 20.1116 27.421 22.2866C27.172 23.4832 26.5587 24.5685 25.6688 25.3871C24.0513 26.875 21.0342 26.875 15 26.875C8.96581 26.875 5.94871 26.875 4.3312 25.3871C3.44135 24.5685 2.82799 23.4832 2.57903 22.2866C2.12649 20.1116 3.63504 17.4423 6.65214 12.1036Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M14.99 20H15.0012"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 16.25L15 11.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CMSIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6618 2.5C20.6531 2.5 23.1488 2.5 24.6994 3.96447C26.25 5.42893 26.25 7.78596 26.25 12.5V17.5C26.25 22.214 26.25 24.5711 24.6994 26.0355C23.1488 27.5 20.6531 27.5 15.6618 27.5H14.3382C9.34689 27.5 6.85122 27.5 5.30061 26.0355C3.75 24.5711 3.75 22.214 3.75 17.5L3.75 12.5C3.75 7.78595 3.75 5.42893 5.30061 3.96447C6.85122 2.5 9.34689 2.5 14.3382 2.5L15.6618 2.5Z"
        stroke="#141B34"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 8.75H20"
        stroke="#141B34"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 15H20"
        stroke="#141B34"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 21.25H15"
        stroke="#141B34"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  FaqIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 14.4584C27.5 21.0623 21.9028 26.4168 15 26.4168C14.1884 26.4178 13.3791 26.3428 12.5818 26.1931C12.0079 26.0853 11.721 26.0314 11.5207 26.062C11.3203 26.0926 11.0365 26.2436 10.4687 26.5455C8.86267 27.3996 6.98994 27.7012 5.18889 27.3662C5.87343 26.5242 6.34093 25.514 6.54722 24.431C6.67222 23.7685 6.3625 23.125 5.89861 22.6539C3.79167 20.5144 2.5 17.6314 2.5 14.4584C2.5 7.85446 8.09722 2.5 15 2.5C21.9028 2.5 27.5 7.85446 27.5 14.4584Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.3077C12.5 11.0332 13.6193 10 15 10C16.3807 10 17.5 11.0332 17.5 12.3077C17.5 12.7671 17.3546 13.1951 17.1039 13.5548C16.3568 14.6265 15 15.6486 15 16.9231V17.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 20.625H15.0112"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  MailAccountIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 9.375L12.4275 11.5493C14.5715 12.8169 15.4285 12.8169 17.5725 11.5493L21.25 9.375"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.495 12.5C27.4917 12.0416 27.4868 12.2127 27.4803 11.9081C27.3986 8.07506 27.3577 6.15853 25.9438 4.73881C24.5299 3.3191 22.5621 3.26964 18.6265 3.17072C16.2009 3.10976 13.7991 3.10976 11.3735 3.17072C7.43791 3.26962 5.4701 3.31908 4.05619 4.73879C2.64228 6.15851 2.60142 8.07504 2.51971 11.9081C2.49343 13.1406 2.49343 14.3658 2.51971 15.5983C2.60143 19.4313 2.64229 21.3479 4.0562 22.7676C5.47011 24.1873 7.43792 24.2367 11.3735 24.3357C12.1335 24.3548 13.1196 24.3679 13.75 24.375"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4825 23.3102C18.6965 23.7709 16.6357 24.7116 17.8909 25.8887C18.504 26.4638 19.1869 26.875 20.0454 26.875H24.9445C25.803 26.875 26.4859 26.4638 27.099 25.8887C28.3542 24.7116 26.2934 23.7709 25.5074 23.3102C23.6643 22.2299 21.3256 22.2299 19.4825 23.3102Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M24.995 17.5C24.995 18.8807 23.8757 20 22.495 20C21.1143 20 19.995 18.8807 19.995 17.5C19.995 16.1193 21.1143 15 22.495 15C23.8757 15 24.995 16.1193 24.995 17.5Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),
  ProfileIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1103_44727)">
        <circle cx="7.99992" cy="7.99967" r="6.66667" stroke="black" />
        <path
          d="M5 11.3337C6.55447 9.70554 9.42882 9.62888 11 11.3337M9.6634 6.33366C9.6634 7.25413 8.91614 8.00033 7.99435 8.00033C7.07257 8.00033 6.32531 7.25413 6.32531 6.33366C6.32531 5.41318 7.07257 4.66699 7.99435 4.66699C8.91614 4.66699 9.6634 5.41318 9.6634 6.33366Z"
          stroke="black"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1103_44727">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ChangePasswordIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1103_44731)">
        <path
          d="M11.9999 7.33608C11.611 6.61136 10.8486 6.10517 9.96786 6.0662C8.98461 6.02269 7.98581 6 6.8859 6C5.78599 6 4.78719 6.02269 3.80394 6.0662C2.63544 6.1179 1.67522 6.99205 1.51913 8.10784C1.41727 8.83604 1.33325 9.58228 1.33325 10.3423C1.33325 11.1022 1.41727 11.8485 1.51913 12.5767C1.67522 13.6925 2.63544 14.5666 3.80394 14.6183C4.28 14.6394 4.84019 14.6556 5.33325 14.6667"
          stroke="black"
          strokeLinecap="round"
        />
        <path
          d="M4 5.99967V4.33301C4 2.67615 5.34315 1.33301 7 1.33301C8.65685 1.33301 10 2.67615 10 4.33301V5.99967"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1363 10.0694L13.786 10.4261L13.786 10.4261L14.1363 10.0694ZM14.3163 10.9468C14.5133 11.1403 14.8299 11.1374 15.0234 10.9404C15.2168 10.7433 15.2139 10.4268 15.0169 10.2333L14.3163 10.9468ZM12.0151 10.0694L11.6648 9.7126L11.6648 9.7126L12.0151 10.0694ZM12.1951 11.9882C12.3922 12.1817 12.7087 12.1788 12.9022 11.9817C13.0957 11.7847 13.0928 11.4681 12.8957 11.2747L12.1951 11.9882ZM9.89371 14.235L9.5434 13.8782C9.15216 14.2624 8.51411 14.2624 8.12287 13.8782L7.77256 14.235L7.42225 14.5918C8.20249 15.3579 9.46378 15.3579 10.244 14.5918L9.89371 14.235ZM7.77256 14.235L8.12287 13.8782C7.73671 13.4991 7.73671 12.8882 8.12287 12.509L7.77256 12.1522L7.42225 11.7955C6.63692 12.5666 6.63692 13.8207 7.42225 14.5918L7.77256 14.235ZM7.77256 12.1522L8.12287 12.509C8.51411 12.1249 9.15216 12.1249 9.5434 12.509L9.89371 12.1522L10.244 11.7955C9.46378 11.0294 8.20249 11.0294 7.42225 11.7955L7.77256 12.1522ZM9.89371 12.1522L9.5434 12.509C9.92955 12.8882 9.92955 13.4991 9.5434 13.8782L9.89371 14.235L10.244 14.5918C11.0293 13.8207 11.0293 12.5666 10.244 11.7955L9.89371 12.1522ZM14.1363 10.0694L13.786 10.4261L14.3163 10.9468L14.6666 10.5901L15.0169 10.2333L14.4866 9.7126L14.1363 10.0694ZM9.89371 12.1522L10.244 12.509L11.8351 10.9468L11.4849 10.5901L11.1346 10.2333L9.54342 11.7955L9.89371 12.1522ZM11.4849 10.5901L11.8352 10.9468L12.3655 10.4261L12.0151 10.0694L11.6648 9.7126L11.1345 10.2333L11.4849 10.5901ZM11.4849 10.5901L11.1345 10.9468L12.1951 11.9882L12.5454 11.6314L12.8957 11.2747L11.8352 10.2333L11.4849 10.5901ZM14.1363 10.0694L14.4866 9.7126C14.2466 9.47699 14.0317 9.26443 13.8348 9.11694C13.626 8.96053 13.3815 8.83301 13.0757 8.83301V9.33301V9.83301C13.0805 9.83301 13.1164 9.82822 13.2352 9.91726C13.366 10.0152 13.526 10.1708 13.786 10.4261L14.1363 10.0694ZM12.0151 10.0694L12.3655 10.4261C12.6255 10.1708 12.7855 10.0152 12.9162 9.91726C13.0351 9.82822 13.0709 9.83301 13.0757 9.83301V9.33301V8.83301C12.7699 8.83301 12.5254 8.96053 12.3166 9.11694C12.1198 9.26443 11.9048 9.47699 11.6648 9.7126L12.0151 10.0694Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1103_44731">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  LogoutIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11.75C9.95093 12.9846 8.92206 14.0329 7.54376 13.9992C7.2231 13.9914 6.82675 13.8796 6.03408 13.656C4.12641 13.1179 2.47037 12.2136 2.07304 10.1877C2 9.8153 2 9.39626 2 8.55817L2 7.44183C2 6.60374 2 6.1847 2.07304 5.8123C2.47037 3.78644 4.12641 2.88211 6.03408 2.34402C6.82676 2.12043 7.2231 2.00864 7.54376 2.00079C8.92206 1.96707 9.95093 3.01538 10 4.25"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M14.0001 7.99967H6.66675M14.0001 7.99967C14.0001 7.53286 12.6705 6.66069 12.3334 6.33301M14.0001 7.99967C14.0001 8.46649 12.6705 9.33865 12.3334 9.66634"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ShieldIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12C3.55208 11.65 2.35677 10.8525 1.41406 9.6075C0.471354 8.3625 0 6.98 0 5.46V1.8L5 0L10 1.8V5.46C10 6.98 9.52865 8.3625 8.58594 9.6075C7.64323 10.8525 6.44792 11.65 5 12ZM3.75 8.4H6.25C6.42708 8.4 6.57552 8.3425 6.69531 8.2275C6.8151 8.1125 6.875 7.97 6.875 7.8V6C6.875 5.83 6.8151 5.6875 6.69531 5.5725C6.57552 5.4575 6.42708 5.4 6.25 5.4V4.8C6.25 4.47 6.1276 4.1875 5.88281 3.9525C5.63802 3.7175 5.34375 3.6 5 3.6C4.65625 3.6 4.36198 3.7175 4.11719 3.9525C3.8724 4.1875 3.75 4.47 3.75 4.8V5.4C3.57292 5.4 3.42448 5.4575 3.30469 5.5725C3.1849 5.6875 3.125 5.83 3.125 6V7.8C3.125 7.97 3.1849 8.1125 3.30469 8.2275C3.42448 8.3425 3.57292 8.4 3.75 8.4ZM4.375 5.4V4.8C4.375 4.63 4.4349 4.4875 4.55469 4.3725C4.67448 4.2575 4.82292 4.2 5 4.2C5.17708 4.2 5.32552 4.2575 5.44531 4.3725C5.5651 4.4875 5.625 4.63 5.625 4.8V5.4H4.375Z"
        fill="#4EBA75"
      />
    </svg>
  ),
  InterruptPtt: (
    <svg
      width="48"
      height="47"
      viewBox="0 0 48 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="47" height="47" rx="23.5" fill="#E24C4C" />
      <rect x="16.5" y="16" width="15" height="15" rx="2" fill="white" />
    </svg>
  ),
  startPtt: (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="32" fill="#4EBA75" />
      <mask
        id="mask0_2328_17"
        maskUnits="userSpaceOnUse"
        x="16"
        y="16"
        width="32"
        height="32"
      >
        <rect x="16" y="16" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2328_17)">
        <path
          d="M32 34.6665C30.8889 34.6665 29.9444 34.2776 29.1667 33.4998C28.3889 32.7221 28 31.7776 28 30.6665V22.6665C28 21.5554 28.3889 20.6109 29.1667 19.8332C29.9444 19.0554 30.8889 18.6665 32 18.6665C33.1111 18.6665 34.0555 19.0554 34.8333 19.8332C35.6111 20.6109 36 21.5554 36 22.6665V30.6665C36 31.7776 35.6111 32.7221 34.8333 33.4998C34.0555 34.2776 33.1111 34.6665 32 34.6665ZM30.6667 43.9998V39.8998C28.3555 39.5887 26.4444 38.5554 24.9333 36.7998C23.4222 35.0443 22.6667 32.9998 22.6667 30.6665H25.3333C25.3333 32.5109 25.9833 34.0832 27.2833 35.3832C28.5833 36.6832 30.1555 37.3332 32 37.3332C33.8444 37.3332 35.4167 36.6832 36.7167 35.3832C38.0167 34.0832 38.6667 32.5109 38.6667 30.6665H41.3333C41.3333 32.9998 40.5778 35.0443 39.0667 36.7998C37.5555 38.5554 35.6444 39.5887 33.3333 39.8998V43.9998H30.6667ZM32 31.9998C32.3778 31.9998 32.6944 31.8721 32.95 31.6165C33.2055 31.3609 33.3333 31.0443 33.3333 30.6665V22.6665C33.3333 22.2887 33.2055 21.9721 32.95 21.7165C32.6944 21.4609 32.3778 21.3332 32 21.3332C31.6222 21.3332 31.3055 21.4609 31.05 21.7165C30.7944 21.9721 30.6667 22.2887 30.6667 22.6665V30.6665C30.6667 31.0443 30.7944 31.3609 31.05 31.6165C31.3055 31.8721 31.6222 31.9998 32 31.9998Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  ChannelBarIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99866 1.6665C7.49218 1.6665 5.86698 3.349 3.94492 3.96226C3.1634 4.21161 2.77264 4.33629 2.6145 4.51205C2.45636 4.6878 2.41005 4.94463 2.31743 5.45828C1.32636 10.9548 3.49258 16.0365 8.65874 18.0144C9.21382 18.2269 9.49135 18.3332 10.0014 18.3332C10.5114 18.3332 10.789 18.2269 11.344 18.0144C16.5098 16.0365 18.674 10.9548 17.6826 5.45828C17.59 4.94454 17.5437 4.68767 17.3855 4.51191C17.2273 4.33615 16.8366 4.21154 16.0551 3.96233C14.1323 3.34912 12.5052 1.6665 9.99866 1.6665Z"
        stroke="#DEE6E8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.8333C7.5 10.8333 8.33333 10.8333 9.16667 12.5C9.16667 12.5 11.8137 8.33333 14.1667 7.5"
        stroke="#DEE6E8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  RemoveIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1003_29066)">
        <path
          d="M10.4165 18.3332H5.49223C4.20441 18.3332 3.1801 17.7065 2.26039 16.8303C0.377641 15.0366 3.46884 13.6032 4.64782 12.9012C6.39848 11.8587 8.4472 11.4764 10.4165 11.7542C11.1311 11.8549 11.827 12.0426 12.4998 12.3173"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 5.4165C13.75 7.48757 12.0711 9.1665 10 9.1665C7.92893 9.1665 6.25 7.48757 6.25 5.4165C6.25 3.34544 7.92893 1.6665 10 1.6665C12.0711 1.6665 13.75 3.34544 13.75 5.4165Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M12.5 15.4165H18.3333"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1003_29066">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  AddIcon: (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9165 18.3332H5.99223C4.70441 18.3332 3.6801 17.7065 2.76039 16.8303C0.877641 15.0366 3.96884 13.6032 5.14782 12.9012C6.89848 11.8587 8.9472 11.4764 10.9165 11.7542C11.6311 11.8549 12.327 12.0426 12.9998 12.3173"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 5.4165C14.25 7.48757 12.5711 9.1665 10.5 9.1665C8.42893 9.1665 6.75 7.48757 6.75 5.4165C6.75 3.34544 8.42893 1.6665 10.5 1.6665C12.5711 1.6665 14.25 3.34544 14.25 5.4165Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M15.9167 18.3333L15.9167 12.5M13 15.4167H18.8333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  AudioUnmuteIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.667 12.3448V7.65555C11.667 5.03455 11.667 3.72405 10.8959 3.39791C10.1248 3.07177 9.21728 3.99844 7.40226 5.85176C6.46232 6.81153 5.92603 7.02407 4.58869 7.02407C3.41914 7.02407 2.83436 7.02407 2.41429 7.31068C1.54228 7.90562 1.6741 9.06849 1.6741 10.0002C1.6741 10.9318 1.54228 12.0947 2.41429 12.6896C2.83436 12.9763 3.41914 12.9763 4.58869 12.9763C5.92603 12.9763 6.46231 13.1888 7.40226 14.1486C9.21728 16.0019 10.1248 16.9286 10.8959 16.6024C11.667 16.2763 11.667 14.9658 11.667 12.3448Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.167 7.5C14.6882 8.18306 15.0003 9.05287 15.0003 10C15.0003 10.9471 14.6882 11.8169 14.167 12.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.667 5.8335C17.7093 6.97193 18.3337 8.42161 18.3337 10.0002C18.3337 11.5787 17.7093 13.0284 16.667 14.1668"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  AudioMuteIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3332 18.3332L1.6665 1.6665"
        stroke="white"
        strokeWidth="0.714286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40177 14.1483L7.9376 13.6236L7.9376 13.6236L7.40177 14.1483ZM2.4138 7.31043L2.83649 7.92997L2.83649 7.92997L2.4138 7.31043ZM2.4138 12.6894L2.83649 12.0699L2.83649 12.0699L2.4138 12.6894ZM10.8954 16.6022L11.1876 17.2929H11.1876L10.8954 16.6022ZM12.4165 11.6666C12.4165 11.2524 12.0807 10.9166 11.6665 10.9166C11.2523 10.9166 10.9165 11.2524 10.9165 11.6666H12.4165ZM7.10318 7.2101C7.42497 6.94928 7.47441 6.47699 7.2136 6.1552C6.95278 5.83341 6.48049 5.78397 6.1587 6.04479L7.10318 7.2101ZM4.5882 7.02382V6.27382C4.01936 6.27382 3.53509 6.27288 3.14246 6.31366C2.73648 6.35583 2.34577 6.44891 1.9911 6.69089L2.4138 7.31043L2.83649 7.92997C2.9019 7.88534 3.01361 7.83512 3.29743 7.80564C3.59459 7.77477 3.98749 7.77382 4.5882 7.77382V7.02382ZM4.5882 12.976V12.226C3.98749 12.226 3.59459 12.2251 3.29743 12.1942C3.01361 12.1647 2.9019 12.1145 2.83649 12.0699L2.4138 12.6894L1.9911 13.3089C2.34577 13.5509 2.73648 13.644 3.14246 13.6862C3.53509 13.727 4.01936 13.726 4.5882 13.726V12.976ZM11.6665 12.3445H10.9165C10.9165 13.6797 10.9147 14.599 10.8272 15.231C10.784 15.5428 10.727 15.7229 10.675 15.8234C10.6331 15.9044 10.6089 15.909 10.6032 15.9114L10.8954 16.6022L11.1876 17.2929C11.9737 16.9604 12.2125 16.1628 12.313 15.4368C12.4183 14.6768 12.4165 13.6304 12.4165 12.3445H11.6665ZM7.40177 14.1483L6.86593 14.6731C7.75573 15.5817 8.48058 16.3245 9.0832 16.7873C9.66005 17.2304 10.3934 17.6288 11.1876 17.2929L10.8954 16.6022L10.6032 15.9114C10.5986 15.9134 10.5834 15.9264 10.505 15.9017C10.4039 15.8698 10.2423 15.7862 9.99692 15.5977C9.49925 15.2155 8.86284 14.5683 7.9376 13.6236L7.40177 14.1483ZM11.6665 11.6666H10.9165V12.3445H11.6665H12.4165V11.6666H11.6665ZM1.67361 9.99992H2.42361C2.42361 9.46561 2.39369 9.05009 2.45752 8.64589C2.51523 8.28046 2.6331 8.06874 2.83649 7.92997L2.4138 7.31043L1.9911 6.69089C1.32249 7.14707 1.07027 7.81425 0.975882 8.41191C0.88762 8.9708 0.923607 9.60255 0.923607 9.99992H1.67361ZM1.67361 9.99992H0.923607C0.923607 10.3973 0.88762 11.029 0.975882 11.5879C1.07027 12.1856 1.32249 12.8528 1.9911 13.3089L2.4138 12.6894L2.83649 12.0699C2.6331 11.9311 2.51523 11.7194 2.45752 11.3539C2.39369 10.9497 2.42361 10.5342 2.42361 9.99992H1.67361ZM7.40177 14.1483L7.9376 13.6236C7.44313 13.1186 6.98916 12.7401 6.43054 12.5091C5.87375 12.279 5.28633 12.226 4.5882 12.226V12.976V13.726C5.22742 13.726 5.57681 13.7793 5.85748 13.8954C6.13632 14.0106 6.42046 14.2182 6.86593 14.6731L7.40177 14.1483ZM4.5882 7.02382V7.77382C4.8882 7.77382 5.34037 7.79704 5.74135 7.75212C6.18005 7.70298 6.66065 7.56877 7.10318 7.2101L6.63094 6.62744L6.1587 6.04479C6.00522 6.16918 5.82685 6.23316 5.57437 6.26144C5.28418 6.29395 5.01299 6.27382 4.5882 6.27382V7.02382Z"
        fill="white"
      />
      <path
        d="M10.8957 3.38861L10.603 4.07915L10.8957 3.38861ZM7.80504 4.462C7.51111 4.75386 7.50944 5.22873 7.8013 5.52265C8.09316 5.81657 8.56803 5.81825 8.86195 5.52639L7.80504 4.462ZM10.9168 7.91683C10.9168 8.33104 11.2526 8.66683 11.6668 8.66683C12.081 8.66683 12.4168 8.33104 12.4168 7.91683H10.9168ZM11.6668 7.65496H12.4168C12.4168 6.36638 12.4185 5.3181 12.3133 4.55678C12.2129 3.82996 11.9744 3.03122 11.1883 2.69807L10.8957 3.38861L10.603 4.07915C10.6085 4.08149 10.6329 4.08615 10.675 4.16774C10.7271 4.26878 10.7843 4.4496 10.8274 4.76213C10.915 5.39568 10.9168 6.31718 10.9168 7.65496H11.6668ZM8.3335 4.99419L8.86195 5.52639C9.46532 4.92726 9.90386 4.5111 10.2542 4.26906C10.6234 4.014 10.6703 4.10766 10.603 4.07915L10.8957 3.38861L11.1883 2.69807C10.5045 2.40823 9.86297 2.71616 9.40154 3.03497C8.92128 3.36678 8.38704 3.88409 7.80504 4.462L8.3335 4.99419ZM11.6668 7.65496H10.9168V7.91683H11.6668H12.4168V7.65496H11.6668Z"
        fill="white"
      />
      <path
        d="M14.1665 8.3335C14.6911 8.97239 14.9998 9.7547 14.9998 10.5997C14.9998 10.9697 14.9407 11.3277 14.8301 11.6668"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6665 6.6665C17.7088 7.6911 18.3332 8.99581 18.3332 10.4165C18.3332 11.5968 17.9022 12.6971 17.1587 13.6232"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LeaveIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 14.6875C12.4387 16.2308 11.1526 17.5412 9.4297 17.499C9.02887 17.4892 8.53344 17.3495 7.5426 17.07C5.15801 16.3974 3.08796 15.267 2.5913 12.7346C2.5 12.2691 2.5 11.7453 2.5913 10.6977L2.5 9.30229C2.5 8.25468 2.5 7.73087 2.5913 7.26538C3.08796 4.73304 5.15801 3.60263 7.5426 2.93002C8.53345 2.65054 9.02887 2.5108 9.4297 2.50099C11.1526 2.45884 12.4387 3.76923 12.5 5.31251"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5002 9.99984H8.3335M17.5002 9.99984C17.5002 9.41631 15.8382 8.32611 15.4168 7.9165M17.5002 9.99984C17.5002 10.5834 15.8382 11.6736 15.4168 12.0832"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  AddMemberIcon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0002 7.3335V14.6668M14.6668 11.0002L7.3335 11.0002"
        stroke="#4EBA75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1668 11.0003C20.1668 5.93771 16.0628 1.83366 11.0002 1.83366C5.93755 1.83366 1.8335 5.93771 1.8335 11.0003C1.8335 16.0629 5.93755 20.167 11.0002 20.167C16.0628 20.167 20.1668 16.0629 20.1668 11.0003Z"
        stroke="#4EBA75"
        strokeWidth="1.5"
      />
    </svg>
  ),
  RemoveMemberIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.667 10.0005L6.33366 10.0005"
        stroke="#E24C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1663 10.0003C19.1663 4.93771 15.0623 0.833656 9.99968 0.833656C4.93706 0.833656 0.833008 4.93771 0.833008 10.0003C0.833008 15.0629 4.93706 19.167 9.99968 19.167C15.0623 19.167 19.1663 15.0629 19.1663 10.0003Z"
        stroke="#E24C4C"
        strokeWidth="1.5"
      />
    </svg>
  ),
  CrossCircleIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#EFF3F8" />
      <path
        d="M13 7L10 10M10 10L7 13M10 10L13 13M10 10L7 7"
        stroke="#E24C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CrossTriangleIcon: (
    <svg
      width="50"
      height="44"
      viewBox="0 0 50 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.5003 38.475L28.2112 1.84213C26.7834 -0.614045 23.2166 -0.614045 21.7888 1.84213L0.49967 38.475C-0.922571 40.9312 0.860766 44 3.71081 44H46.2892C49.1392 44 50.9226 40.9312 49.5003 38.475ZM22.9889 12.7873H27.0111C27.85 12.7873 28.5112 13.4993 28.4389 14.3272L27.5389 24.9909C27.4778 25.7305 26.8556 26.299 26.1111 26.299H23.8889C23.1444 26.299 22.5222 25.7305 22.4611 24.9909L21.5611 14.3272C21.4888 13.4993 22.15 12.7873 22.9889 12.7873ZM25 38.039C23.0889 38.039 21.5389 36.499 21.5389 34.6003C21.5389 32.7016 23.0889 31.1617 25 31.1617C26.9111 31.1617 28.4611 32.7016 28.4611 34.6003C28.4611 36.499 26.9111 38.039 25 38.039Z"
        fill="#E24C4C"
      />
    </svg>
  ),
  QRCodeIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4C2 3.05719 2 2.58579 2.29289 2.29289C2.58579 2 3.05719 2 4 2C4.94281 2 5.41421 2 5.70711 2.29289C6 2.58579 6 3.05719 6 4C6 4.94281 6 5.41421 5.70711 5.70711C5.41421 6 4.94281 6 4 6C3.05719 6 2.58579 6 2.29289 5.70711C2 5.41421 2 4.94281 2 4Z"
        stroke="#007AFF"
        strokeWidth="1.5"
      />
      <path
        d="M2 12C2 11.0572 2 10.5858 2.29289 10.2929C2.58579 10 3.05719 10 4 10C4.94281 10 5.41421 10 5.70711 10.2929C6 10.5858 6 11.0572 6 12C6 12.9428 6 13.4142 5.70711 13.7071C5.41421 14 4.94281 14 4 14C3.05719 14 2.58579 14 2.29289 13.7071C2 13.4142 2 12.9428 2 12Z"
        stroke="#007AFF"
        strokeWidth="1.5"
      />
      <path
        d="M2 8L6 8"
        stroke="#007AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2V5.33333"
        stroke="#007AFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4C10 3.05719 10 2.58579 10.2929 2.29289C10.5858 2 11.0572 2 12 2C12.9428 2 13.4142 2 13.7071 2.29289C14 2.58579 14 3.05719 14 4C14 4.94281 14 5.41421 13.7071 5.70711C13.4142 6 12.9428 6 12 6C11.0572 6 10.5858 6 10.2929 5.70711C10 5.41421 10 4.94281 10 4Z"
        stroke="#007AFF"
        strokeWidth="1.5"
      />
      <path
        d="M14 8H10C9.05719 8 8.58579 8 8.29289 8.29289C8 8.58579 8 9.05719 8 10M8 11.8462V13.6923M10 10V11C10 11.9642 10.5224 12 11.3333 12C11.7015 12 12 12.2985 12 12.6667M10.6667 14H10M12 10C12.9428 10 13.4142 10 13.7071 10.2933C14 10.5866 14 11.0587 14 12.0029C14 12.9471 14 13.4192 13.7071 13.7125C13.4933 13.9265 13.1845 13.9844 12.6667 14"
        stroke="#007AFF"
        strokeLinecap="round"
      />
    </svg>
  ),
  LeftArrowIcon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6665 10.9998L18.3332 10.9998"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24956 15.5834C8.24956 15.5834 3.66627 12.2078 3.66626 11C3.66625 9.79225 8.24959 6.41675 8.24959 6.41675"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SettingsIcon: (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      aria-hidden="true"
      height="16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      />
    </svg>
  ),
};

export default SvgIcons;
